import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { MarkdownEditorKiraRole } from '@catch/markdown-editor';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CompanionEditorTextResult,
  CompanionJobResponse,
} from '../components/companion/companion.interface';

@Injectable({
  providedIn: 'root',
})
export class CompanionAdapter {
  private http = inject(HttpClient);

  parseJobOfferPdf(
    payload: FormData
  ): Observable<{ result: CompanionJobResponse; error: string }> {
    return this.http.post<{ result: CompanionJobResponse; error: string }>(
      `${environment.apiBaseUrl}/company/companion/parse-job-offer-pdf`,
      payload
    );
  }

  generateEditorText(
    prompt: string,
    role: MarkdownEditorKiraRole
  ): Observable<CompanionEditorTextResult> {
    return this.http.post<CompanionEditorTextResult>(
      `${environment.apiBaseUrl}/company/companion/generate-text`,
      { prompt, role }
    );
  }

  optimizeEditorText(
    text: string,
    role: MarkdownEditorKiraRole,
    prompt?: string
  ): Observable<CompanionEditorTextResult> {
    const body: { text: string; role: MarkdownEditorKiraRole; prompt?: string } =
      { text, role };
    if (prompt !== undefined && prompt.trim() !== '') {
      body.prompt = prompt.trim();
    }
    return this.http.post<CompanionEditorTextResult>(
      `${environment.apiBaseUrl}/company/companion/optimize-text`,
      body
    );
  }
}
